import { isEngineConfiguration } from './validator';
export function normalizeModelId(modelId) {
    return ((modelId &&
        modelId.replace(/[^a-zA-Z0-9\d]+/g, '$').replace(/^\$+|\$+$/g, '')) ||
        '');
}
export function normalizeConfiguration(configuration) {
    return Object.assign(Object.assign({}, configuration), (isEngineConfiguration(configuration) && {
        modelId: normalizeModelId(configuration.modelId),
    }));
}
